import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LinkedInSidebar from './LinkedInSidebar';
import axios from "axios";
import Cookies from "js-cookie";
import { SquareX, SquareCheck, Info, Loader2, Check } from "lucide-react";
import Modal from './Elements/Modal';
import TableFromJson from './Elements/TableFromJson';
import ReactMarkdown from 'react-markdown';
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);
import { useLocation } from 'react-router-dom';

const SubscriptionPage = ({ currentPage, setCurrentPage, setTitleDescription, authStatus }) => {
  // useEffect(() => {
  //   if(authStatus === false) {
  //     setCurrentPage('auth/login')
  //   }
  // }, [authStatus]);

  useEffect(() => {
    setTitleDescription("Fractofolio - Subscriptions - Pro Accounts", "The future of investment networking! Discover market insights, and make informed investment decisions with our community.")
  }, []);

  const [loading, setLoading] = useState(true);
  const [loadingButton, setLoadingButton] = useState(true);
  const [currentTariffPlanEnd, setCurrentTariffPlanEnd] = useState("free");
  const [currentTariffPlan, setCurrentTariffPlan] = useState('');
  const [cancelModal, setCancelModal] = useState(false);
  const [cancelAtPeriodEnd, setCancelAtPeriodEnd] = useState(false);
  
  useEffect(() => {
    getCurrentTariffPlan();
  }, []);

  async function subscribeStripe(price_id) {
    setLoadingButton(true);

    const data = {
      token: Cookies.get('token'),
      price_id: price_id
    }

    if(currentTariffPlan == "") {
      try {
        const apiURL = process.env.REACT_APP_API_URL;
        const response = await axios.post(apiURL+'/stripe/create_payment', data);
        if(response.data.status === 'ok') {
          // setAccountConnected(response.data.account_connected);
          // setAccountDetails(response.data.account_details);
          window.location.href = response.data.url;
        } else {
          // setError(response.data.text);
        }
      } catch(err) {

      }
    } else {
      try {
        const apiURL = process.env.REACT_APP_API_URL;
        const response = await axios.post(apiURL+'/stripe/update_subscription_plan', data);
        if(response.data.status === 'ok') {
          setCurrentTariffPlan(response.data.tariff_plan);
        } else {
          // setError(response.data.text);
        }
      } catch(err) {

      }
    }
    setLoadingButton(false);
  }
  
  async function changePaymentMethodStripe() {
    setLoadingButton(true);

    const data = {token: Cookies.get('token')}

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+'/stripe/change_payment_method', data);
      if(response.data.status === 'ok') {
        // setAccountConnected(response.data.account_connected);
        // setAccountDetails(response.data.account_details);
        window.location.href = response.data.url;
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
  
    setLoadingButton(false);
  }

  async function cancelSubscriptionStrip() {
    setLoadingButton(true);

    try {
      const data = {token: Cookies.get('token')}
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+'/stripe/cancel_subscription', data);
      if(response.data.status === 'ok') {
        await getCurrentTariffPlan();
        setCancelModal(false);
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
  
    setLoadingButton(false);
  }

  async function dontCancelSubscriptionStripe() {
    setLoadingButton(true);

    try {
      const data = {token: Cookies.get('token')}
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+'/stripe/dont_cancel_subscription', data);
      if(response.data.status === 'ok') {
        await getCurrentTariffPlan();
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
  
    setLoadingButton(false);
  }

  async function getCurrentTariffPlan() {
    setLoading(true);
    setLoadingButton(true);

    const data = {
      token: Cookies.get('token')
    }

    try {
      const apiURL = process.env.REACT_APP_API_URL;
      const response = await axios.post(apiURL+'/subscriptions/get_current_tariff_plan', data);
      if(response.data.status === 'ok') {
        setCurrentTariffPlan(response.data.tariff_plan);
        setCurrentTariffPlanEnd(convertTimestampToYmdHisUTC(response.data.current_period_end));
        setCancelAtPeriodEnd(response.data.cancel_at_period_end);
      } else {
        // setError(response.data.text);
      }
    } catch(err) {

    }
    setLoadingButton(false);
    setLoading(false);
  }

  function convertTimestampToYmdHisUTC(timestamp) {
    // Convert timestamp to Date object
    let date = new Date(timestamp * 1000);

    // Define options for formatting the date
    let options = { 
      month: 'long',         // "July"
      day: 'numeric',        // "3"
      year: 'numeric',       // "2025"
      hour: 'numeric',       // "11"
      minute: '2-digit',     // "25"
      hour12: true,          // Use AM/PM format
      timeZone: 'UTC'
    };

    // Format the date
    let formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }
  
  return (
    <div className="linkedin-layout bg-gray-50 min-h-screen">

      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          <div className="hidden lg:block lg:col-span-1">
            <LinkedInSidebar currentPage={currentPage} setCurrentPage={setCurrentPage} />
          </div>

          {loading === true && (
            <div className="lg:col-span-3 space-y-6">
              <div className='mx-auto w-fit'>
                <button className="linkedin-action-btn" disabled={loading}>
                  <span>Loading...</span>
                </button>
              </div>
            </div>
          )}
          
          {loading === false && (
            <div className="lg:col-span-3 space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                
                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Free</h2>
                    <div className="font-regular text-left text-sm">
                      0$ / month
                    </div>
                  </div>
                  <div className="linkedin-card-content">

                    <span className="flex justify-left items-center font-medium">
                      Limited Metrics Analysis
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      Limited Financial History
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      Limited AI Analysis
                    </span>
                    <hr className="mt-2 mb-2" />
                    
                    <span className="flex justify-left items-center font-medium">
                      Limited Notifications for Company Evaluations
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      Ad supported
                    </span>
                    <hr className="mt-2 mb-2" />

                    {currentTariffPlan == '' && (
                      <button disabled={true} className="mt-3 linkedin-btn-secondary w-full">
                        <span>Current Plan</span>
                      </button>
                    )}

                  </div>
                </div>

                <div className="linkedin-card">
                  <div className="linkedin-card-header">
                    <h2 className="text-xl font-bold text-gray-900">Pro</h2>
                    <div className="font-regular text-left text-sm">
                      9.99$ / month
                    </div>
                  </div>
                  <div className="linkedin-card-content">
                    
                    <span className="flex justify-left items-center font-medium">
                      Unlimited access to all data and tools
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      Financial history: 10 years
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      Unlimited AI Analysis
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      Unlimited Notifications for Company Evaluations
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      No ads
                    </span>
                    <hr className="mt-2 mb-2" />

                    <span className="flex justify-left items-center font-medium">
                      More features coming soon
                    </span>
                    <hr className="mt-2 mb-2" />

                    {authStatus === true && currentTariffPlan != 'pro' && (
                      <button onClick={() => subscribeStripe('price_1RgvKzIEGgrqpWugawGVuFI8')} disabled={loadingButton} className="mt-3 linkedin-btn-primary w-full">
                        {loadingButton === true && (
                          <span>Loading...</span>
                        )}
                        {loadingButton === false && (
                          <span>Get Started Now</span>
                        )}
                      </button>
                    )}

                    {authStatus === true && currentTariffPlan == 'pro' && (
                      <button disabled={true} className="mt-3 linkedin-btn-secondary w-full">
                        <span>Current Plan</span>
                      </button>
                    )}

                    {authStatus === false && (
                      <button onClick={() => setCurrentPage('auth/login')} className="mt-3 linkedin-btn-primary w-full">
                        <span>Get Started Now</span>
                      </button>
                    )}

                  </div>
                </div>

              </div>

              {currentTariffPlan != '' && (
                <div className="grid grid-cols-1 md:grid-cols-1 gap-0">

                  <div className="row">
                    <div className="col-12">
                      <button onClick={() => changePaymentMethodStripe()} disabled={loadingButton} className="text-xs font-semibold px-6 py-2 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 border-2 border-gray-400">
                        {loadingButton === false && (
                          <span>Change Payment Method (Debit/Credit Card)</span>
                        )}
                        {loadingButton === true && (
                          <span>Loading...</span>
                        )}
                      </button>
                    </div>
                  </div>
                  
                  {cancelAtPeriodEnd === false && (
                    <>
                      <small className="mt-2 text-xs font-regular">
                        Renewal date: {currentTariffPlanEnd} (UTC)
                      </small>

                      <div className="row">
                        <div className="col-12">
                          <a href="#" onClick={() => setCancelModal(true)} className="text-xs text-gray-500 font-medium underline">
                            {loadingButton === false && (
                              <span>Cancel Subscription</span>
                            )}
                            {loadingButton === true && (
                              <span>Loading...</span>
                            )}
                          </a>
                        </div>
                      </div>

                      <Modal isOpen={cancelModal} onClose={() => setCancelModal(false)}>
                        <h2 className="linkedin-title">Are you sure you want to cancel the subscription?</h2>
                        <p className="linkedin-body-text mb-4">The subscription will be canceled at the end of the current period: {currentTariffPlanEnd} (UTC)</p>

                        <div className="flex justify-between">
                          <button onClick={() => cancelSubscriptionStrip()} disabled={loadingButton} className="linkedin-btn-secondary d-block mx-auto">
                            {loadingButton === false && (
                              <span>Cancel Subscription</span>
                            )}
                            {loadingButton === true && (
                              <span>Loading...</span>
                            )}
                          </button>
                          <button onClick={() => setCancelModal(false)} className="linkedin-btn-primary d-block mx-auto border">Close window</button>
                        </div>

                      </Modal>

                    </>
                  )}

                  {cancelAtPeriodEnd === true && (
                    <>
                      <small className="mt-2 text-xs font-regular">
                        The subscription will be canceled at the end of the current period: {currentTariffPlanEnd} (UTC)
                      </small>

                      <div className="row">
                        <div className="col-12">
                          <button onClick={() => dontCancelSubscriptionStripe()} disabled={loadingButton} className="text-xs font-semibold px-6 py-2 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 border-2 border-gray-400">
                            {loadingButton === false && (
                              <span>Don't Cancel Subscription</span>
                            )}
                            {loadingButton === true && (
                              <span>Loading...</span>
                            )}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              )}






            </div>
          )}
          

        </div>

      </div>

    </div>  
  );
};

export default SubscriptionPage;
